import { Delta } from "@vueup/vue-quill";
import { TEACHER_COMMENT_ATTRIBUTE, TEACHER_DELETION_VALUE } from "./useTeacherCommentCorrections";

const normalizedColor = (color: unknown) => {
  if (!color) return "";
  const value = String(color).trim().toLowerCase();
  if (value === "black") return "#000000";
  if (/^#[0-9a-f]{3}$/.test(value)) {
    return `#${value.slice(1).split("").map(char => char + char).join("")}`;
  }
  const rgb = value.match(/^rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/);
  if (rgb) return `#${rgb.slice(1).map(channel => Number(channel).toString(16).padStart(2, "0")).join("")}`;
  return value;
};

// One editor change keeps the color and acceptance together in Undo/Redo.
export const useTextColorDelta = (selection: Delta, index: number, color: string | null | false) => {
  const change = new Delta().retain(index);
  for (const op of selection.ops ?? []) {
    const length = typeof op.insert === "string" ? op.insert.length : 1;
    const marker = op.attributes?.[TEACHER_COMMENT_ATTRIBUTE];
    const isCorrection = marker === true || marker === "true" || marker === TEACHER_DELETION_VALUE;
    change.retain(length, {
      color: color || null,
      ...(isCorrection && normalizedColor(color) !== normalizedColor(op.attributes?.color)
        ? { [TEACHER_COMMENT_ATTRIBUTE]: null }
        : {}),
    });
  }
  return change;
};
